import React, { useState } from 'react';
import firebase from '../config/firebase';

const UpdateEmailPage = () => {
  const [oldEmail, setOldEmail] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailUpdate = async () => {
    if (!oldEmail || !newEmail) {
      setMessage("Unesi obje email adrese.");
      return;
    }

    setIsLoading(true);
    setMessage("");

    try {
      const questionsRef = firebase.database().ref('app_questions');
      const snapshot = await questionsRef.once('value');
      const data = snapshot.val();

      if (!data) {
        setMessage("Nema pitanja u bazi.");
        setIsLoading(false);
        return;
      }

      const updates = {};
      Object.entries(data).forEach(([id, item]) => {
        if (item.email === oldEmail) {
          updates[`/${id}/email`] = newEmail;
        }
      });

      if (Object.keys(updates).length === 0) {
        setMessage("Nema pitanja s tom email adresom.");
      } else {
        await questionsRef.update(updates);
        setMessage("Email uspješno ažuriran.");
      }
    } catch (error) {
      console.error("Greška prilikom ažuriranja:", error);
      setMessage("Došlo je do greške.");
    }

    setIsLoading(false);
    setOldEmail('');
    setNewEmail('');
  };

  return (
    <div style={{ maxWidth: "600px", margin: "40px auto", padding: "20px", border: "1px solid #ddd", borderRadius: "10px", backgroundColor: "#f9f9f9" }}>
      <h2 style={{ marginBottom: "20px", textAlign: "center" }}>Zamijeni Email u pitanjima</h2>
      
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <input
          type="email"
          placeholder="Stari email"
          value={oldEmail}
          onChange={(e) => setOldEmail(e.target.value)}
          style={{ padding: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
        />
        <input
          type="email"
          placeholder="Novi email"
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
          style={{ padding: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
        />
        <button
          onClick={handleEmailUpdate}
          disabled={isLoading}
          style={{
            padding: "10px",
            backgroundColor: "#28a745",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer"
          }}
        >
          {isLoading ? "Ažuriranje..." : "Ažuriraj Email"}
        </button>

        {message && <div style={{ marginTop: "15px", color: "#333", textAlign: "center" }}>{message}</div>}
      </div>
    </div>
  );
};

export default UpdateEmailPage;
